import { render } from "./SlideUpDown.vue?vue&type=template&id=10765d0c&scoped=true"
import script from "./SlideUpDown.vue?vue&type=script&lang=js"
export * from "./SlideUpDown.vue?vue&type=script&lang=js"

import "./SlideUpDown.vue?vue&type=style&index=0&id=10765d0c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10765d0c"],['__file',"webpack-assets/vue/components/SlideUpDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10765d0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10765d0c', __exports__)) {
    api.reload('10765d0c', __exports__)
  }
  
  module.hot.accept("./SlideUpDown.vue?vue&type=template&id=10765d0c&scoped=true", () => {
    api.rerender('10765d0c', render)
  })

}


export default __exports__